// Theme entry script. The `js` class gates any CSS that should only apply
// when JavaScript is available (progressive enhancement hook).
document.documentElement.classList.add('js');

// Form time-trap: stamp every mp-form's hidden `ts` field with the page-load
// time (ms). inc/forms.php rejects submissions filled in under 3s of this
// stamp (bot behavior) or older than 24h (replay) — see its file docblock.
for (const field of document.querySelectorAll('.mp-form input[name="ts"]')) {
  field.value = String(Date.now());
}
